module.exports = __webpack_public_path__ + "static/media/edit.7e1bf521.svg";